import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { Hero } from './components/Hero';
import { MetricsSection } from './components/MetricsSection';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { TomosSection } from './components/TomosSection';
import { IncludesSection } from './components/IncludesSection';
import { BonusSection } from './components/BonusSection';
import { OfferSection } from './components/OfferSection';
import { CostSection } from './components/CostSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { WhatsAppTestimonials } from './components/WhatsAppTestimonials';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen w-full bg-ink-900 font-sans" data-id="element-0" data-mp="23utadzydnu97">
      <Hero data-id="element-1" data-mp="3ikr0s4yore8d" />
      <main data-id="element-2" data-mp="3iiwg8rrbto4t">
        <MetricsSection data-id="element-3" data-mp="3ijfvu1ti80fo" />
        <Testimonials data-id="element-4" data-mp="3ihuyy5jpw5en" />
        <PainPoints data-id="element-5" data-mp="3mlaxx8j9ehui" />
        <TomosSection data-id="element-6" data-mp="3mkrcviybbdc9" />
        <IncludesSection data-id="element-7" data-mp="3mjzs7369700r" />
        <BonusSection data-id="element-8" data-mp="3mj6ibtbzzuee" />
        <OfferSection data-id="element-9" data-mp="3rcj7c4kla37o" />
        <CostSection data-id="element-10" data-mp="3rdaqgfx028h2" />
        <GuaranteeSection data-id="element-11" data-mp="3rcsw5otwe4bs" />
        <FaqSection data-id="element-12" data-mp="3relu8fqg3g86" />
        <WhatsAppTestimonials data-id="element-13" data-mp="5orv1p50w72" />
        <FinalCta data-id="element-14" data-mp="4wylxj0jajy" />
      </main>
      <Footer data-id="element-15" data-mp="82kz509bybz" />
    </div>;
}